import React, { FC, Suspense, useState } from 'react'
import { renderRoutes, RouteConfigComponentProps } from 'react-router-config'
import { makeStyles } from '@material-ui/core/styles'
import { LinearProgress } from '@material-ui/core'
import TopBar from '../../Organisms/Topbar/Topbar'
import NavBar from '../../Organisms/NavBar/NavBar'
import Footer from '../../Molecules/Footer/Footer'

const useStyles = makeStyles(() => ({
    root: {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    topBar: {
        zIndex: 2,
    },
    container: {
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
    },
    navBar: {
        zIndex: 3,
        width: 256,
        minWidth: 256,
        flex: '0 0 auto',
    },
    content: {
        overflowY: 'auto',
        flex: '1 1 auto',
        display: 'flex',
        minHeight: '100vh',
        flexDirection: 'column',
    },
}))

const Dashboard: FC<RouteConfigComponentProps<any>> = ({ route }) => {
    const mainRef = React.createRef<HTMLElement>()
    const classes = useStyles()
    const [openNavBar, setOpenNavBar] = useState(false)

    const handleNavBarOpen = () => {
        setOpenNavBar(true)
    }

    const handleNavBarClose = () => {
        setOpenNavBar(false)
    }

    return (
        <div className={classes.root}>
            <TopBar className={classes.topBar} forwardedRef={mainRef} onOpenNavBar={handleNavBarOpen} />
            <div className={classes.container}>
                <NavBar className={classes.navBar} onClose={handleNavBarClose} open={openNavBar} />
                <main className={classes.content} ref={mainRef}>
                    <Suspense fallback={<LinearProgress />}>{renderRoutes(route.routes)}</Suspense>
                    <Footer />
                </main>
            </div>
        </div>
    )
}

export default Dashboard
